import { GameId } from '@bg-shared/enums/GameId';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { ITipsResponse } from './interfaces/ITipsResponse';

export default class TipsAPI {
    public placeTip(gameId: GameId, amount: number, runId: number): Promise<ITipsResponse> {
        return httpClientRepository.post<ITipsResponse>(API_URLS.TIPS, {
            data: {
                gameId,
                amount,
                runId,
            },
        });
    }
}

export const tipsAPI = new TipsAPI();
